export const blockIconsTextformattingSummarizeNew = (
	<span className='material-symbols-outlined'>summarize</span>
);
